// frontend/shared-ui/src/forms/schemas/splitter.js
const ADAPTER_CODES = { Simplex: 'SX', Duplex: 'DX', Quad: 'QX' };

export default {
    slug: 'splitter',
    label: 'Splitters & Couplers',
    defaultUnit: 'pcs',
    costDefaults: {
        avgVolumeCbm: 0.0015,
        suggestedMarkupPct: 45,
        freightSensitivity: 'low',
        note: 'Boxed splitters 1×4/1×8 — small CBM, high margin',
    },
    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 2,
            fields: [
                {
                    key: 'splitRatio', label: 'Split Ratio', type: 'select', required: true,
                    options: ['1x2', '1x4', '1x8', '1x16', '1x32', '1x64', '2x2', '2x4', '2x8']
                },
                {
                    key: 'technology', label: 'Technology', type: 'select', required: true,
                    options: ['PLC', 'FBT']
                },
            ],
        },
        {
            id: 'optical',
            label: 'Optical',
            columns: 3,
            fields: [
                {
                    key: 'wavelengthRange', label: 'Wavelength Range', type: 'text',
                    placeholder: '1260 – 1650 nm'
                },
                {
                    key: 'connectorType', label: 'Connector', type: 'select',
                    options: ['None', 'SC', 'LC', 'FC', 'ST']
                },
                {
                    key: 'polishType', label: 'Polish', type: 'select',
                    options: [{ value: 'APC', label: 'APC (Green)' }, { value: 'UPC', label: 'UPC (Blue)' }]
                },
                {
                    key: 'fiberMode', label: 'Fiber Mode', type: 'select', required: true,
                    options: [{ value: 'Singlemode', label: 'Singlemode' }, { value: 'Multimode', label: 'Multimode' }]
                },
                {
                    key: 'adapterType', label: 'Adapter', type: 'select',
                    options: ['Simplex', 'Duplex', 'Quad']
                },
                { key: 'uniformity', label: 'Uniformity', type: 'number', unit: 'dB', step: 0.01 },
                { key: 'insertionLoss', label: 'Insertion Loss', type: 'number', unit: 'dB', step: 0.01 },
                { key: 'returnLoss', label: 'Return Loss', type: 'number', unit: 'dB', step: 0.01 },
                { key: 'directivity', label: 'Directivity', type: 'number', unit: 'dB', step: 0.01 },
            ],
        },
        {
            id: 'physical',
            label: 'Physical',
            columns: 3,
            fields: [
                {
                    key: 'packageType', label: 'Package', type: 'select',
                    options: ['Cassette', 'Module', 'Bare Fiber', 'Rack Mount', 'LGX']
                },
                { key: 'rackUnits', label: 'Rack Units', type: 'select', options: ['1U', '2U', 'Cassette'] },
                {
                    key: 'color', label: 'Color', type: 'select',
                    options: ['Black', 'Blue', 'Green', 'White', 'Grey']
                },
            ],
        },
    ],

    buildSku(v) {
        const parts = [
            'SPL',
            v.splitRatio || '',
            v.technology || '',
            v.connectorType && v.connectorType !== 'None' ? v.connectorType : '',
            v.polishType || '',
            ADAPTER_CODES[v.adapterType] || '',
        ];
        return parts.filter(Boolean).join('-').toUpperCase().replace(/X/g, 'X');
    },

    buildName(v) {
        const bits = [];
        if (v.splitRatio) bits.push(v.splitRatio);
        if (v.technology) bits.push(v.technology);
        bits.push('Splitter');
        if (v.connectorType && v.connectorType !== 'None') {
            const c = v.polishType ? `${v.connectorType}/${v.polishType}` : v.connectorType;
            bits.push(c);
        }
        if (v.wavelengthRange) bits.push(`(${v.wavelengthRange})`);
        return bits.join(' ');
    },

    attributeSchema: [
        { key: 'splitRatio', label: 'Split Ratio' },
        { key: 'technology', label: 'Technology' },
        { key: 'wavelengthRange', label: 'Wavelength Range' },
        { key: 'connectorType', label: 'Connector' },
        { key: 'polishType', label: 'Polish' },
        { key: 'fiberMode', label: 'Fiber Mode' },
        { key: 'adapterType', label: 'Adapter' },
        { key: 'uniformity', label: 'Uniformity', unit: 'dB' },
        { key: 'insertionLoss', label: 'Insertion Loss', unit: 'dB' },
        { key: 'returnLoss', label: 'Return Loss', unit: 'dB' },
        { key: 'directivity', label: 'Directivity', unit: 'dB' },
        { key: 'packageType', label: 'Package' },
        { key: 'rackUnits', label: 'Rack Units' },
        { key: 'color', label: 'Color' },
    ],
};